const React = require("react");
const { MdClose, MdAdd } = require("react-icons/md");
const {
  MAX_DESTINATION_COUNTRIES, DESTINATION_COUNTRIES, countryName, addCountry, removeCountry, replaceCountry,
} = require("../../cjShippingDestinations");
const h = React.createElement;

const ERROR_TEXT = {
  DUPLICATE_COUNTRY: ["h_cjms_err_duplicate", "This country is already selected."],
  TOO_MANY_COUNTRIES: ["h_cjms_err_max", "You can compare at most {max} countries."],
  COUNTRIES_REQUIRED: ["h_cjms_err_min", "Keep at least one destination country."],
  INVALID_COUNTRY: ["h_cjms_err_invalid", "Choose a valid country."],
};

// 1 to 4 destination countries, no duplicates; each chip can be replaced or
// removed. Each selected country is then quoted independently.
const CJCountrySelector = ({ countries, onChange, t, disabled = false }) => {
  const [error, setError] = React.useState("");
  const [adding, setAdding] = React.useState("");

  const apply = ({ countries: next, error: code }) => {
    if (code) {
      const [key, fallback] = ERROR_TEXT[code] || ERROR_TEXT.INVALID_COUNTRY;
      setError(t(key, fallback, { max: MAX_DESTINATION_COUNTRIES }));
      return;
    }
    setError("");
    onChange(next);
  };

  const full = countries.length >= MAX_DESTINATION_COUNTRIES;
  const optionsFor = (current) => DESTINATION_COUNTRIES
    .filter(([code]) => code === current || !countries.includes(code))
    .map(([code, name]) => h("option", { key: code, value: code }, `${name} (${code})`));

  return h("div", { className: "cjms-countries" },
    h("div", { className: "cjms-section-head" },
      h("label", { className: "cjms-label" }, t("h_cjms_countries", "Destination countries")),
      h("span", { className: `cjms-count${full ? " cjms-count--full" : ""}`, "aria-live": "polite" },
        t("h_cjms_countries_count", "{count} / {max} countries selected", { count: countries.length, max: MAX_DESTINATION_COUNTRIES }))
    ),
    h("div", { className: "cjms-chips" },
      ...countries.map((code) => h("div", { key: code, className: "cjms-chip" },
        h("select", {
          "aria-label": t("h_cjms_replace_country", "Replace {country}", { country: countryName(code) }),
          value: code,
          disabled,
          onChange: (e) => apply(replaceCountry(countries, code, e.target.value)),
        }, ...optionsFor(code)),
        h("button", {
          type: "button",
          className: "cjms-chip__remove",
          disabled: disabled || countries.length <= 1,
          title: t("h_cjms_remove_country", "Remove {country}", { country: countryName(code) }),
          "aria-label": t("h_cjms_remove_country", "Remove {country}", { country: countryName(code) }),
          onClick: () => apply(removeCountry(countries, code)),
        }, h(MdClose))
      )),
      !full ? h("div", { className: "cjms-chip cjms-chip--add" },
        h(MdAdd, { "aria-hidden": true }),
        h("select", {
          "aria-label": t("h_cjms_add_country", "Add a country"),
          value: adding,
          disabled,
          onChange: (e) => { setAdding(""); if (e.target.value) apply(addCountry(countries, e.target.value)); },
        },
          h("option", { value: "" }, t("h_cjms_add_country", "Add a country")),
          ...optionsFor(null))
      ) : null
    ),
    error ? h("p", { className: "cjds-field-error", role: "alert" }, error) : null
  );
};

module.exports = { CJCountrySelector };
